/*
 Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
  */
RCA.client.Modulsettings = (function () {
    'use strict';

    /* ----- Init Settings -------------------------------------------------------------------------------------------- */
    function Init() {

        BuildFromSource();
        return true;
    }

    function BuildFromSource() {
        $.post('api/', {
            do: 'getModulSettings'
        }, function (data) {
            RCA.shared.AppData.modulsettings = data;
            RCA.client.Docs.renderList();
            RCA.client.Profile.Init();

            ToggleRedAlert();
            RCA.client.Agenda.Build();
            RCA.client.Agenda.showFavorite("sub");
            RCA.client.Agenda.showFavorite();
            RCA.client.Agenda.toggleRequestSpeakerGotoLink();
            RCA.client.Agenda.toggleItemArrows();

            RCA.client.Speakers.toggleRequestBusinessCard();
            RCA.client.Speakers.toggleRequestSpeakerGotoLink();
            RCA.client.Speakers.toggleSocial();
            RCA.client.Speakers.renderList();
            RCA.client.Speakers.renderDetails();
            RCA.client.Attendees.toggleRequestBusinessCard();
            RCA.client.Attendees.toggleSocial();
            RCA.client.Attendees.renderList();

            RCA.client.Gallery.renderDetails();
            RCA.client.Photos.renderList();

            RCA.client.Broadcast.setRunawayDatas();
            RCA.client.Broadcast.setBroadcastPoster();
            RCA.client.Broadcast.BuildBroadcast();
            RCA.client.Broadcast.showReactions();
            RCA.client.Broadcast.showTranslator();
            RCA.client.Broadcast.showChatButton();
            RCA.client.Broadcast.showTexttracks();
            RCA.client.Trueconf.showTranslator();

            RCA.client.Translator.toggleRelayBtns();

            RCA.client.Messageboard.showMsgBoard();
            if (!RCA.shared.AppData.modulsettings.attentionchecker) {
                RCA.client.Broadcast.disableAttentionGuard();
            } else {
                RCA.client.Broadcast.enableAttentionGuard();
            }
            RCA.client.Issues.renderList();
            RCA.client.Issues.renderDetails();

            if (RCA.shared.AppData.modulsettings.showvideochat) {
                $("#chat-details .video-chat").show();
            } else {
                $("#chat-details .video-chat").hide();
            }

            RCA.client.Chat.refresh();

            let $layouts = $('div.main');
            /* Set Title*/
            $layouts.find('.header-primary .data-title').text(RCA.shared.AppData.modulsettings.title[RCA.shared.localState.lang]);

            /* Set SubTitle */
            $layouts.find('.header-primary .data-subtitle').text(RCA.shared.AppData.modulsettings.subTitle[RCA.shared.localState.lang]);

            if (RCA.shared.AppData.settings.foregroundtype == "text") {
                $layouts.filter('#landing').find('.hero').html(RCA.shared.AppData.modulsettings.fgtext[RCA.shared.localState.lang]);
            }

            RCA.client.Issues.maxCharacterCount();

            RCA.client.Bookings.BuildFromSourceClient();

            Update();

            data = null;
        });
    }

    function ToggleRedAlert() {
        $("#landing").find('.open-main.broadcast').toggleClass('blinkingicon', RCA.shared.AppData.modulsettings.showredalert);
        $("#landing").find('#default_nav .open-main.broadcast').toggleClass('color-primary', !RCA.shared.AppData.modulsettings.showredalert);

        if (RCA.shared.AppData.modulsettings.showredalert) {
            $("#landing").find('.open-main.broadcast').css("color", RCA.shared.AppData.settings.colorPrimary);
        } else {
            $("#landing").find('.open-main.broadcast').css("color", "");
        }

    }

    function Update() {
        if (RCA.shared.AppData.modulsettings.cdown_showonclient == false && RCA.shared.AppData.modulsettings.bc_landingbutton == false) {
            $("#landing .countdown_bc").hide();
        } else {
            $("#landing .countdown_bc").show();
        }

        RCA.shared.showCountDown(RCA.shared.AppData.modulsettings.cdown_showonclient, RCA.shared.AppData.modulsettings.cdown_clientpos);

        if (RCA.shared.AppData.modulsettings.bc_landingbutton) {
            $("#landing .countdown_bc .bc_button").show();
        } else {
            $("#landing .countdown_bc .bc_button").hide();
        }

        if (RCA.shared.AppData.profile.group == "translator" && RCA.shared.AppData.modulsettings.translator_disallow_mic) {
            $("#landing #trueconf_iframe").attr("allow", "microphone 'none'; camera; autoplay; display-capture");
        } else {
            $("#landing #trueconf_iframe").attr("allow", "microphone; camera; autoplay; display-capture");
        }

        if (["top", "bottom", "left"].indexOf(RCA.shared.AppData.modulsettings.emoji_pos) > -1) {
            $(".stream_reactions").removeClass("top bottom left").addClass(RCA.shared.AppData.modulsettings.emoji_pos);
        } else {
            $(".stream_reactions").removeClass("top bottom left").addClass("bottom");
        }

        if (RCA.shared.AppData.modulsettings.show_quickmenu) {
            $("#minimal_nav").appendTo($(".bodycontent"));
            if (RCA.shared.localState.layout.length > 0) {
                $("#minimal_nav").addClass("topAnimationDown");
            }
            RCA.client.Navigation.setMinimalisticMenu();
        }

        $('nav#minimal_nav').toggle(RCA.shared.AppData.modulsettings.show_quickmenu);

        if (RCA.shared.AppData.modulsettings.show_quickmenu) {
            $("#docs-details embed").addClass("w_quickmenu");
        } else {
            $("#docs-details embed").removeClass("w_quickmenu");
        }

        if ('landingbutton_bgcolor' in RCA.shared.AppData.modulsettings && 'landingbutton_textcolor' in RCA.shared.AppData.modulsettings) {
            var inlineStyle = '.landingbutton { color: ' + RCA.shared.AppData.modulsettings.landingbutton_textcolor + ' !important; background-color: ' + RCA.shared.AppData.modulsettings.landingbutton_bgcolor + ' !important;}';
            inlineStyle += '.play-btn-cont { color: ' + RCA.shared.AppData.modulsettings.landingbutton_bgcolor + ' !important;}';
            $('head').append('<style>' + inlineStyle + '</style>');
        }
    }

    /* ----- Public API --------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        BuildFromSource: BuildFromSource,
        Update: Update
    };
})();
